import { Autocomplete, Stack, TextField, styled } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ValidationLabel } from "src/components/Form";
import { LocationResponse } from "src/models/locations/LocationResponse";

const AutoCompleteTextField = styled(TextField)`
  .MuiInputBase-root {
    border-radius: 0;
    padding-top: 6px;
    padding-bottom: 6px;
  }
`;

type LocationSelectProps = {
  name: string;
  value: string[];
  locations: LocationResponse[];
  hasError?: boolean;
  errorMessage?: string;
  onChange: (value: string[]) => void;
};

export const LocationSelect: React.FC<LocationSelectProps> = ({
  name,
  errorMessage,
  locations,
  onChange,
  value,
}: LocationSelectProps) => {
  const [validationMessage, setValidationMessage] = useState<string>(errorMessage);
  const [autoValue, setAutoValue] = useState<LocationResponse | null>(null);
  const [inputValue, setInputValue] = React.useState("");

  useEffect(() => {
    if (!value || value.length == 0) {
      setAutoValue(null);
      setInputValue("");
    }
  }, [value]);

  useEffect(() => {
    setValidationMessage(errorMessage);
  }, [errorMessage]);

  return (
    <>
      <Stack direction="column" spacing={2}>
        <Stack direction="row" spacing={2} marginBottom={2} marginTop={0} justifyContent="center">
          <Autocomplete
            id={`location-autocomplete-${name}`}
            getOptionLabel={(option) => (typeof option === "string" ? option : `${option.id} - ${option.name}`)}
            filterOptions={(options, { inputValue }) =>
              options.filter((opt) => {
                const search = inputValue.toLowerCase();
                return opt.name?.toLowerCase().includes(search) || opt.id?.toString().includes(search);
              })
            }
            options={locations}
            autoComplete
            inputValue={inputValue}
            filterSelectedOptions
            value={autoValue}
            onInputChange={(event, newInputValue) => {
              setInputValue(newInputValue);
            }}
            onChange={(event: any, newValue: LocationResponse | null) => {
              onChange(newValue ? [newValue.id.toString()] : null);
              setAutoValue(newValue);
            }}
            style={{ boxShadow: "2px 2px 0 0 var(--palette-primary-shadow__1yqyf5p6)", flexGrow: 1 }}
            renderInput={(params) => <AutoCompleteTextField {...params} placeholder="Search by Location" fullWidth />}
            slotProps={{
              popper: {
                disablePortal: true,
                placement: "bottom",
              },
            }}
          />
        </Stack>
      </Stack>
      <ValidationLabel errorMessage={validationMessage} />
    </>
  );
};
